// Helper to get nested property from object
const get = (obj, path, defaultValue) => {
  if (!obj) return defaultValue
  const keys = path.split('.')
  let result = obj
  for (const key of keys) {
    if (result === null || result === undefined) return defaultValue
    result = result[key]
  }
  return result === undefined ? defaultValue : result
}

const combineValidators = validators => value =>
  validators.reduce((error, validator) => error || validator(value), undefined)

const validate = (value, validator) => {
  if (typeof validator === 'function') return validator(value)
  else if (Array.isArray(validator)) return combineValidators(validator)(value)
  else if (
    typeof validator === 'object' &&
    validator !== null &&
    !Array.isArray(validator)
  ) {
    const _errors = {}
    Object.keys(validator).forEach(
      key => (_errors[key] = validate(get(value, key), get(validator, key)))
    )
    // Remove undefined values
    const errors = Object.fromEntries(
      Object.entries(_errors).filter(([_, v]) => v !== undefined)
    )
    return Object.keys(errors).length === 0 ? undefined : errors
  }
}

export default validate
